import React from 'react';
import { graphql } from 'gatsby';

import PageBanner from '../components/page-banner/page-banner.component';
import PrivacyPolicy from '../components/legal-documents/privacy-policy/privacy-policy.component';
import { Helmet } from 'react-helmet';

export const query = graphql`
  query StrapiPrivacyPolicy {
    strapiPrivacyPolicy(status: { eq: "published" }) {
      content
      updated_at
    }
  }
`;

type PrivacyPolicyPageProps = {
  data: GatsbyTypes.StrapiPrivacyPolicyQuery;
};

const PrivacyPolicyPage: React.FC<PrivacyPolicyPageProps> = ({
  data: {
    strapiPrivacyPolicy: { content, updated_at },
  },
}) => {
  return (
    <>
      <Helmet title="Privacy Policy" />
      <PageBanner
        pageTitle="Privacy Policy"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Privacy Policy"
      />
      <PrivacyPolicy {...{ content }} lastModified={updated_at} />
    </>
  );
};

export default PrivacyPolicyPage;
